import { MultiMediaReponseType } from '../../../utils/types';
import './style.css';
import { Video } from '@chatui/core';

export interface VideoCardProps {
  video: MultiMediaReponseType;
}

const VideoCard = ({ video }: VideoCardProps) => {
  const { data } = video;
  if (!data || data.length === 0) return null;

  return data.map((item: any, index: number) => {
    return (
      <div className="video-card" key={index}>
        <Video src={item.media}></Video>
      </div>
    );
  });
};

export default VideoCard;
